module.exports = __webpack_public_path__ + "static/media/7.4e632380.JPG";